export const PERSONAL_INTERACTIVE_SAVINGS_CALCULATOR_EXPERIMENT_ID = '22103000682'
export const AUTO_INSURANCE_WIDGET_SPLIT_EXPERIMENT_ID = '39289236706'

const vtConfig = [
  {
    id: '50600573151',
    name: 'IS Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'student-loan/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 IS Widget CTA IS PQ form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 IS Widget CTA IS Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: '62336686311',
    name: 'SLR Widgets Rate Table Link CTA to Landing Page',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'student-loan-refi/rate-table.*theme=fox.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 SLR Widget CTA SLR form',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 SLR Widget CTA SLR Landing Page',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: PERSONAL_INTERACTIVE_SAVINGS_CALCULATOR_EXPERIMENT_ID,
    name: 'PL Savings Calculator vs Interactive Widget',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'personal-loan/rich-cta.*variation=interactive.*theme=fox.*?|personal-loan/rich-cta.*theme=fox.*variation=interactive.*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 Baseline PL Interactive Widget',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 PL Savings Calculator Widget',
        isPaused: false,
        weight: 0.5,
      },
    ],
    gaCustomDimension: 100,
  },
  {
    id: AUTO_INSURANCE_WIDGET_SPLIT_EXPERIMENT_ID,
    name: 'Auto Insurance Widget Split',
    isManualTriggering: false,
    isRunning: true,
    isMobile: true,
    isDesktop: true,
    isTablet: true,
    allowOrganicTraffic: true,
    allowNonOrganicTraffic: true,
    urlConditions: [
      {
        url: 'auto-insurance/simple-cta.*variation=(compare-insurance-rates|learn-more|learn-about-auto-insurance|get-quotes).*?',
        type: 'regexp',
      },
    ],
    variations: [
      {
        id: 0,
        description: 'V0 Gabi Blog',
        isPaused: false,
        weight: 0.5,
      },
      {
        id: 1,
        description: 'V1 Jerry Blog',
        isPaused: false,
        weight: 0.5,
      },
    ],
  },
]

export default vtConfig
